var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ServiceNotFoundError } from './error/service-not-found.error';
import { CannotInstantiateValueError } from './error/cannot-instantiate-value.error';
import { Token } from './token.class';
import { EMPTY_VALUE } from './empty.const';
import { ContainerRegistry } from './container-registry.class';
/**
 * TypeDI can have multiple containers.
 * One container is ContainerInstance.
 */
var ContainerInstance = /** @class */ (function () {
    function ContainerInstance(id) {
        var _a;
        /** Metadata for all registered services in this container. */
        this.metadataMap = new Map();
        /**
         * Services registered with 'multiple: true' are saved as simple services
         * with a generated token and the mapping between the original ID and the
         * generated one is stored here. This is handled like this to allow simplifying
         * the inner workings of the service instance.
         */
        this.multiServiceIds = new Map();
        /**
         * All registered handlers. The @Inject() decorator uses handlers internally to mark a property for injection.
         **/
        this.handlers = [];
        /**
         * Indicates if the container has been disposed or not.
         * Any function call should fail when called after being disposed.
         *
         * NOTE: Currently not in used
         */
        this.disposed = false;
        this.id = id;
        ContainerRegistry.registerContainer(this);
        /**
         * TODO: This is to replicate the old functionality. This should be copied only
         * TODO: if the container decides to inherit registered classes from a parent container.
         */
        this.handlers = ((_a = ContainerRegistry.defaultContainer) === null || _a === void 0 ? void 0 : _a.handlers) || [];
    }
    /**
     * Checks if the service with given name or type is registered service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */
    ContainerInstance.prototype.has = function (identifier) {
        this.throwIfDisposed();
        return !!this.metadataMap.has(identifier) || !!this.multiServiceIds.has(identifier);
    };
    /**
     * Retrieves the service with given name or type from the service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */
    ContainerInstance.prototype.get = function (identifier) {
        this.throwIfDisposed();
        var global = ContainerRegistry.defaultContainer.metadataMap.get(identifier);
        var local = this.metadataMap.get(identifier);
        /** If the service is registered as global we load it from there, otherwise we use the local one. */
        var metadata = (global === null || global === void 0 ? void 0 : global.scope) === 'singleton' ? global : local;
        /** This should never happen as multi services are masked with custom token in Container.set. */
        if (metadata && metadata.multiple === true) {
            throw new Error("Cannot resolve multiple values for ".concat(identifier.toString(), " service!"));
        }
        /** Otherwise it's returned from the current container. */
        if (metadata) {
            return this.getServiceValue(metadata);
        }
        /**
         * If it's the first time requested in the child container we load it from parent and set it.
         * TODO: This will be removed with the container inheritance rework.
         */
        if (global && this !== ContainerRegistry.defaultContainer) {
            var clonedService = __assign({}, global);
            clonedService.value = EMPTY_VALUE;
            /**
             * We need to immediately set the empty value from the root container
             * to prevent infinite lookup in cyclic dependencies.
             */
            this.set(clonedService);
            var value = this.getServiceValue(clonedService);
            this.set(__assign(__assign({}, clonedService), { value: value }));
            return value;
        }
        throw new ServiceNotFoundError(identifier);
    };
    /**
     * Gets all instances registered in the container of the given service identifier.
     * Used when service defined with multiple: true flag.
     */
    ContainerInstance.prototype.getMany = function (identifier) {
        var _this = this;
        this.throwIfDisposed();
        var globalIdMap = ContainerRegistry.defaultContainer.multiServiceIds.get(identifier);
        var localIdMap = this.multiServiceIds.get(identifier);
        /**
         * If the service is registered as singleton we load it from default
         * container, otherwise we use the local one.
         */
        if ((globalIdMap === null || globalIdMap === void 0 ? void 0 : globalIdMap.scope) === 'singleton') {
            return globalIdMap.tokens.map(function (generatedId) { return ContainerRegistry.defaultContainer.get(generatedId); });
        }
        if (localIdMap) {
            return localIdMap.tokens.map(function (generatedId) { return _this.get(generatedId); });
        }
        throw new ServiceNotFoundError(identifier);
    };
    /**
     * Sets a value for the given type or service name in the container.
     */
    ContainerInstance.prototype.set = function (serviceOptions) {
        this.throwIfDisposed();
        /**
         * If the service is marked as singleton, we set it in the default container.
         * (And avoid an infinite loop via checking if we are in the default container or not.)
         */
        if (serviceOptions.scope === 'singleton' && ContainerRegistry.defaultContainer !== this) {
            ContainerRegistry.defaultContainer.set(serviceOptions);
            return this;
        }
        var newMetadata = __assign(__assign({ 
            /**
             * Typescript cannot understand that if ID doesn't exists then type must exists based on the
             * typing so we need to explicitly cast this to a `ServiceIdentifier`
             */
            id: (serviceOptions.id || serviceOptions.type), type: serviceOptions.type || null, factory: serviceOptions.factory, value: serviceOptions.value || EMPTY_VALUE, multiple: serviceOptions.multiple || false, eager: serviceOptions.eager || false, scope: serviceOptions.scope || 'container' }, serviceOptions), { referencedBy: new Map().set(this.id, this) });
        /** If the incoming metadata is marked as multiple we mask the ID and continue saving as single value. */
        if (serviceOptions.multiple) {
            var maskedToken = new Token("MultiMaskToken-".concat(newMetadata.id.toString()));
            var existingMultiGroup = this.multiServiceIds.get(newMetadata.id);
            if (existingMultiGroup) {
                existingMultiGroup.tokens.push(maskedToken);
            }
            else {
                this.multiServiceIds.set(newMetadata.id, { scope: newMetadata.scope, tokens: [maskedToken] });
            }
            /**
             * We mask the original metadata with this generated ID, mark the service
             * as  and continue multiple: false and continue. Marking it as
             * non-multiple is important otherwise Container.get would refuse to
             * resolve the value.
             */
            newMetadata.id = maskedToken;
            newMetadata.multiple = false;
        }
        var existingMetadata = this.metadataMap.get(newMetadata.id);
        if (existingMetadata) {
            /** Service already exists, we overwrite it. (This is legacy behavior.) */
            // TODO: Here we should differentiate based on the received set option.
            Object.assign(existingMetadata, newMetadata);
        }
        else {
            /** This service hasn't been registered yet, so we register it. */
            this.metadataMap.set(newMetadata.id, newMetadata);
        }
        /**
         * If the service is eager, we need to create an instance immediately except
         * when the service is also marked as transient. In that case we ignore
         * the eager flag to prevent creating a service what cannot be disposed later.
         */
        if (newMetadata.eager && newMetadata.scope !== 'transient') {
            this.get(newMetadata.id);
        }
        return this;
    };
    /**
     * Removes services with a given service identifiers.
     */
    ContainerInstance.prototype.remove = function (identifierOrIdentifierArray) {
        var _this = this;
        this.throwIfDisposed();
        if (Array.isArray(identifierOrIdentifierArray)) {
            identifierOrIdentifierArray.forEach(function (id) { return _this.remove(id); });
        }
        else {
            var serviceMetadata = this.metadataMap.get(identifierOrIdentifierArray);
            if (serviceMetadata) {
                this.disposeServiceInstance(serviceMetadata);
                this.metadataMap.delete(identifierOrIdentifierArray);
            }
        }
        return this;
    };
    /**
     * Gets a separate container instance for the given instance id.
     */
    ContainerInstance.prototype.of = function (containerId) {
        if (containerId === void 0) { containerId = 'default'; }
        this.throwIfDisposed();
        if (containerId === 'default') {
            return ContainerRegistry.defaultContainer;
        }
        var container;
        if (ContainerRegistry.hasContainer(containerId)) {
            container = ContainerRegistry.getContainer(containerId);
        }
        else {
            /**
             * This is deprecated functionality, for now we create the container if it's doesn't exists.
             * This will be reworked when container inheritance is reworked.
             */
            container = new ContainerInstance(containerId);
        }
        return container;
    };
    /**
     * Registers a new handler.
     */
    ContainerInstance.prototype.registerHandler = function (handler) {
        this.handlers.push(handler);
        return this;
    };
    /**
     * Helper method that imports given services.
     */
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    ContainerInstance.prototype.import = function (services) {
        this.throwIfDisposed();
        return this;
    };
    /**
     * Completely resets the container by removing all previously registered services from it.
     */
    ContainerInstance.prototype.reset = function (options) {
        var _this = this;
        if (options === void 0) { options = { strategy: 'resetValue' }; }
        this.throwIfDisposed();
        switch (options.strategy) {
            case 'resetValue':
                this.metadataMap.forEach(function (service) { return _this.disposeServiceInstance(service); });
                break;
            case 'resetServices':
                this.metadataMap.forEach(function (service) { return _this.disposeServiceInstance(service); });
                this.metadataMap.clear();
                this.multiServiceIds.clear();
                break;
            default:
                throw new Error('Received invalid reset strategy.');
        }
        return this;
    };
    ContainerInstance.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.reset({ strategy: 'resetServices' });
                        /** We mark the container as disposed, forbidding any further interaction with it. */
                        this.disposed = true;
                        /**
                         * Placeholder, this function returns a promise in preparation to support async services.
                         */
                        return [4 /*yield*/, Promise.resolve()];
                    case 1:
                        /**
                         * Placeholder, this function returns a promise in preparation to support async services.
                         */
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContainerInstance.prototype.throwIfDisposed = function () {
        if (this.disposed) {
            // TODO: Use custom error.
            throw new Error('Cannot use container after it has been disposed.');
        }
    };
    /**
     * Gets the value belonging to passed in `ServiceMetadata` instance.
     *
     * - if `serviceMetadata.value` is already set it is immediately returned
     * - otherwise the requested type is resolved to the value saved to `serviceMetadata.value` and returned
     */
    ContainerInstance.prototype.getServiceValue = function (serviceMetadata) {
        var value = EMPTY_VALUE;
        /**
         * If the service value has been set to anything prior to this call we return that value.
         * NOTE: This part builds on the assumption that transient dependencies has no value set ever.
         */
        if (serviceMetadata.value !== EMPTY_VALUE) {
            return serviceMetadata.value;
        }
        /** If both factory and type is missing, we cannot resolve the requested ID. */
        if (!serviceMetadata.factory && !serviceMetadata.type) {
            throw new CannotInstantiateValueError(serviceMetadata.id);
        }
        /**
         * If a factory is defined it takes priority over creating an instance via `new`.
         * The return value of the factory is not checked, we believe by design that the user knows what he/she is doing.
         */
        if (serviceMetadata.factory) {
            /**
             * If we received the factory in the [Constructable<Factory>, "functionName"] format, we need to create the
             * factory first and then call the specified function on it.
             */
            if (serviceMetadata.factory instanceof Array) {
                var factoryInstance = void 0;
                try {
                    /** Try to get the factory from TypeDI first, if failed, fall back to simply initiating the class. */
                    factoryInstance = this.get(serviceMetadata.factory[0]);
                }
                catch (error) {
                    if (error instanceof ServiceNotFoundError) {
                        factoryInstance = new serviceMetadata.factory[0]();
                    }
                    else {
                        throw error;
                    }
                }
                value = factoryInstance[serviceMetadata.factory[1]](this, serviceMetadata.id);
            }
            else {
                /** If only a simple function was provided we simply call it. */
                value = serviceMetadata.factory(this, serviceMetadata.id);
            }
        }
        /**
         * If no factory was provided and only then, we create the instance from the type if it was set.
         */
        if (!serviceMetadata.factory && serviceMetadata.type) {
            var constructableTargetType = serviceMetadata.type;
            // setup constructor parameters for a newly initialized service
            var paramTypes = (Reflect === null || Reflect === void 0 ? void 0 : Reflect.getMetadata('design:paramtypes', constructableTargetType)) || [];
            var params = this.initializeParams(constructableTargetType, paramTypes);
            // "extra feature" - always pass container instance as the last argument to the service function
            // this allows us to support javascript where we don't have decorators and emitted metadata about dependencies
            // need to be injected, and user can use provided container to get instances he needs
            params.push(this);
            value = new (constructableTargetType.bind.apply(constructableTargetType, __spreadArray([void 0], params, false)))();
            // TODO: Calling this here, leads to infinite loop, because @Inject decorator registerds a handler
            // TODO: which calls Container.get, which will check if the requested type has a value set and if not
            // TODO: it will start the instantiation process over. So this is currently called outside of the if branch
            // TODO: after the current value has been assigned to the serviceMetadata.
            // this.applyPropertyHandlers(constructableTargetType, value as Constructable<unknown>);
        }
        /** If this is not a transient service, and we resolved something, then we set it as the value. */
        if (serviceMetadata.scope !== 'transient' && value !== EMPTY_VALUE) {
            serviceMetadata.value = value;
        }
        if (value === EMPTY_VALUE) {
            /** This branch should never execute, but better to be safe than sorry. */
            throw new CannotInstantiateValueError(serviceMetadata.id);
        }
        if (serviceMetadata.type) {
            this.applyPropertyHandlers(serviceMetadata.type, value);
        }
        return value;
    };
    /**
     * Initializes all parameter types for a given target service class.
     */
    ContainerInstance.prototype.initializeParams = function (target, paramTypes) {
        var _this = this;
        return paramTypes.map(function (paramType, index) {
            var paramHandler = _this.handlers.find(function (handler) {
                /**
                 * @Inject()-ed values are stored as parameter handlers and they reference their target
                 * when created. So when a class is extended the @Inject()-ed values are not inherited
                 * because the handler still points to the old object only.
                 *
                 * As a quick fix a single level parent lookup is added via `Object.getPrototypeOf(target)`,
                 * however this should be updated to a more robust solution.
                 *
                 * TODO: Add proper inheritance handling: either copy the handlers when a class is registered what
                 * TODO: has it's parent already registered as dependency or make the lookup search up to the base Object.
                 */
                return handler.object === target && handler.index === index;
            }) ||
                _this.handlers.find(function (handler) {
                    return handler.object === Object.getPrototypeOf(target) && handler.index === index;
                });
            if (paramHandler)
                return paramHandler.value(_this);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            if (paramType && paramType.name && !_this.isPrimitiveParamType(paramType.name)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                return _this.get(paramType);
            }
            return undefined;
        });
    };
    /**
     * Checks if given parameter type is primitive type or not.
     */
    ContainerInstance.prototype.isPrimitiveParamType = function (paramTypeName) {
        return ['string', 'boolean', 'number', 'object'].includes(paramTypeName.toLowerCase());
    };
    /**
     * Applies all registered handlers on a given target class.
     */
    ContainerInstance.prototype.applyPropertyHandlers = function (target, instance) {
        var _this = this;
        this.handlers.forEach(function (handler) {
            if (typeof handler.index === 'number')
                return;
            if (handler.object.constructor !== target && !(target.prototype instanceof handler.object.constructor))
                return;
            if (handler.propertyName) {
                instance[handler.propertyName] = handler.value(_this);
            }
        });
    };
    /**
     * Checks if the given service metadata contains a destroyable service instance and destroys it in place. If the service
     * contains a callable function named `destroy` it is called but not awaited and the return value is ignored..
     *
     * @param serviceMetadata the service metadata containing the instance to destroy
     * @param force when true the service will be always destroyed even if it's cannot be re-created
     */
    ContainerInstance.prototype.disposeServiceInstance = function (serviceMetadata, force) {
        if (force === void 0) { force = false; }
        this.throwIfDisposed();
        /** We reset value only if we can re-create it (aka type or factory exists). */
        var shouldResetValue = force || !!serviceMetadata.type || !!serviceMetadata.factory;
        if (shouldResetValue) {
            /** If we wound a function named destroy we call it without any params. */
            if (typeof (serviceMetadata === null || serviceMetadata === void 0 ? void 0 : serviceMetadata.value)['dispose'] === 'function') {
                try {
                    serviceMetadata.value.dispose();
                }
                catch (error) {
                    /** We simply ignore the errors from the destroy function. */
                }
            }
            serviceMetadata.value = EMPTY_VALUE;
        }
    };
    return ContainerInstance;
}());
export { ContainerInstance };
//# sourceMappingURL=container-instance.class.js.map